module.exports = __webpack_public_path__ + "static/media/PilbaraNews-devicecomp-min@2x.01c5475a.webp";